import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=495bfe4a&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=495bfe4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495bfe4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495bfe4a')) {
      api.createRecord('495bfe4a', component.options)
    } else {
      api.reload('495bfe4a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=495bfe4a&scoped=true&", function () {
      api.rerender('495bfe4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseRequests/edit.vue"
export default component.exports